import { observer } from "mobx-react";
import _ from "lodash";
import NavBar from "../../shared/navbar";
import { useMemo } from "react";
import {
  faBowlFood,
  faGear,
  faLayerGroup,
  faMoneyBill,
  faMoneyBillTrendUp,
  faMotorcycle,
  faPlusSquare,
  faShoppingBag,
  faTriangleExclamation,
  faPercentage,
  faUsersCog,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface IHomePageAdmin {
  isShopAdmin: boolean;
}

const HomePageAdmin = observer(({ isShopAdmin }: IHomePageAdmin) => {
  const menu = useMemo(() => {
    const menuItems = [
      { menu: "Orders", route: "orders", icon: faShoppingBag },
      { menu: "Dine-In Order", route: "tbl-orders", icon: faUtensils },
      { menu: "Products", route: "manage-products", icon: faBowlFood },
      { menu: "Product Categories", route: "manage-cats", icon: faLayerGroup },
      { menu: "Add-Ons", route: "manage-addons", icon: faPlusSquare },
      {
        menu: "Allergens",
        route: "manage-allergens",
        icon: faTriangleExclamation,
      },
      { menu: "Product Offers", route: "manage-offers", icon: faPercentage },
      { menu: "Vouchers", route: "manage-vouchers", icon: faMoneyBill },
      { menu: "Delivery Drivers", route: "manage-drivers", icon: faMotorcycle },
    ];

    if (!isShopAdmin) return menuItems;

    return [
      ...menuItems,
      { menu: "Shop Settings", route: "shop-settings", icon: faGear },
      { menu: "Finance", route: "manage-fin", icon: faMoneyBillTrendUp },
      { menu: "Users", route: "manage-users", icon: faUsersCog },
    ];
  }, [isShopAdmin]);
  return (
    <section className="admin-home bg-cover vh-100 position-relative">
      <NavBar bgClass="bg-default-transparent" />
      <nav className="nav nav-pills d-flex align-items-center justify-content-center mt-5">
        {menu.map((m) => (
          <a
            key={m.route}
            href={`/${m.route}`}
            className="nav-item nav-link text-white bg-default p-lg-5 p-md-5 p-sm-4 p-4 m-3 rounded-5 main-menu-buttons"
          >
            <FontAwesomeIcon className="me-2" icon={m.icon as IconProp} />
            {m.menu}
          </a>
        ))}
      </nav>
    </section>
  );
});

export default HomePageAdmin;
